import {
  IsInformationCorrect,
  MfePersonalInfoClientMfeFieldsPayload,
} from '@interfaces/mfe/mfe-personal-info-client.interface';
import { createAction, props } from '@ngrx/store';

export interface MfePersonalInfoClientPayload {
  isInformationCorrect: IsInformationCorrect | null;
  personalInfo: {
    affiliationStartDate: string;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    birthDate: string;
    citizenshipStatus: string;
    gender: string;
    countryOfCitizenship: string;
    suffix: string;
    ssn?: string;
  };
}

export const UpdateMfePersonalInfoClientData = createAction(
  '[MFE Personal Info Client] Update Data',
  props<{ payload: MfePersonalInfoClientPayload }>(),
);

export const UpdateMfePersonalInfoClientMfeFields = createAction(
  '[MFE Personal Info Client] Update MFE Fields',
  props<{ payload: MfePersonalInfoClientMfeFieldsPayload }>(),
);

export const ResetMfePersonalInfoClientData = createAction('[MFE Personal Info Client] Reset Data');
